import BoardEdit from './BoardEdit';

export default BoardEdit;
